<template>
  <div>
    <v-menu
      offset-y
      :max-width="mobile ? 'auto' : '340px'"
      :min-width="mobile ? '200px' : '280px'"
      bottom
      rounded="lg"
    >
      <template v-slot:activator="{ on }">
        <v-badge overlap :color="dot_status ? 'error' : null" dot class="mx-2">
          <v-btn small icon v-on="on" @click="readNotification()">
            <v-icon>mdi-bell</v-icon>
          </v-btn>
        </v-badge>
      </template>
      <v-list class="py-0">
        <v-container>
          <v-row>
            <v-col cols="9" class="py-0" align="left">
              <span class="text_title_4">การแจ้งเตือนทั้งหมด</span>
            </v-col>
            <v-col cols="3" class="py-0" align="right">
              <v-chip class="mt-1" small dark color="error" v-if="notification_counter > 0">
                <span class="text_body_6 mt-1">{{ notification_counter }}</span>
              </v-chip>
            </v-col>
          </v-row>
        </v-container>

        <v-list class="py-0">
          <v-list-item class="ma-1" style="background-color:#EEEEEE">
            <v-list-item-content>
              <v-list-item-title style="line-height:1.6">
                <span class="text_body_5">ใหม่</span>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-list-item-action-text class="text_body_5 mt-1">
                {{
                notification_counter_const
                }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-list class="py-0 mx-1" dense>
          <v-divider></v-divider>
          <v-list-item
            v-for="(item, index) in notification_list_today"
            :key="index"
            @click="goPage(item.emailRequest)"
          >
            <v-list-item-avatar>
              <img src="@/assets/icon/User.svg" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text_title_5 mt-1">
                {{
                item.emailRequest
                }}
              </v-list-item-title>
              <v-list-item-subtitle class="text_body_5 mt-1">ได้แสดงความคิดเห็น</v-list-item-subtitle>
              <v-list-item-subtitle class="text_body_7 text-right">
                {{
                formatAMPM(item.createdAt)
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list class="py-0">
          <v-list-item class="ma-1" style="background-color:#EEEEEE">
            <v-list-item-content>
              <v-list-item-title style="line-height:1.6">
                <span class="text_body_5">ก่อนหน้านี้</span>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-list-item-action-text class="text_body_5 mt-1">
                {{
                notification_counter_yesterday_const
                }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-list class="py-0 mx-1" dense>
          <v-divider></v-divider>
          <v-list-item
            v-for="(item, index) in notification_list_yesterday"
            :key="index"
            @click="goPage(item.emailRequest)"
          >
            <v-list-item-avatar>
              <img src="@/assets/icon/User.svg" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="text_title_5 mt-1">
                {{
                item.emailRequest
                }}
              </v-list-item-title>
              <v-list-item-subtitle class="text_body_5 mt-1">ได้แสดงความคิดเห็น</v-list-item-subtitle>
              <v-list-item-subtitle class="text_body_7 text-right">
                {{
                "Yesterday, " + formatAMPM(item.createdAt)
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-spacer></v-spacer>
          <v-divider></v-divider>
        </v-list>
        <v-list class="py-0">
          <v-list-item to="/requestword" style="background-color:#EEEEEE" class="text-center ma-1">
            <v-list-item-content>
              <v-list-item-title style="line-height:1.6" to="/requestword">
                <span class="text_body_5">ดูความคิดเห็นทั้งหมด</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { bus } from "@/main";
export default {
  data() {
    return {
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      dot_status: false,
      notification_counter: 0,
      notification_counter_const: 0,
      notification_counter_yesterday_const: 0,
      today: "",
      yesterday: "",
      const_list_today: 3,
      notification_list_today: [],
      const_list_yesterday: 3,
      notification_list_yesterday: [],
    };
  },
  watch: {},
  computed: {
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    // EventBus
    bus.$on("getNotificationCounter", (data) => {
      this.getNotificationCounter("normal");
    });
    this.$session.get("notification")
      ? this.getNotificationCounter("created")
      : this.initNotification();
    this.getNotificationCounterYesterday();
  },
  beforeDestroy() {
    bus.$off("getNotificationCounter");
  },
  methods: {
    readNotification() {
      this.dot_status = false;
      if (this.$session.get("notification") != this.notification_counter) {
        this.$session.set("notification", this.notification_counter_const);
      } else {
        this.notification_counter = 0;
      }
      // console.log(this.$session.getAll());
    },
    initNotification() {
      this.$session.set("notification", 0);
      this.getNotificationCounter("created");
    },
    getNotificationCounter(state) {
      this.setDate();
      this.axios
        .get(
          process.env.VUE_APP_API +
            "/api/v1/requestword/count?date=" +
            this.today
        )
        .then((response) => {
          // console.log(response.data);
          this.notification_counter_const = response.data.count;
          if (response.data.count >= 0) {
            if (response.data.count - this.$session.get("notification") > 0) {
              // set new
              // console.log("noti > 0");
              this.notification_counter =
                response.data.count - this.$session.get("notification");
              this.dot_status = true;
              if (state != "created") {
                // get List today normal case
                this.axios
                  .get(
                    process.env.VUE_APP_API +
                      "api/v1/requestword/page/" +
                      this.const_list_today +
                      "/1?start=" +
                      this.today +
                      "&end=" +
                      this.today +
                      "&mode=notification" +
                      "&languageId=&search="
                  )
                  .then((response) => {
                    // console.log(response.data);
                    this.notification_list_today = response.data;
                  })
                  .catch((err) => {});
              }
            } else if (
              response.data.count - this.$session.get("notification") ==
              0
            ) {
              // console.log("noti = 0");
              this.notification_counter = 0;
              this.dot_status = false;
            } else {
              // reset noti this a new day
              // console.log("noti < 0");
              this.notification_counter = 0;
              this.dot_status = false;
              this.$session.set("notification", 0);
            }
          }
          if (state == "created") {
            // get List today created case
            this.axios
              .get(
                process.env.VUE_APP_API +
                  "api/v1/requestword/page/" +
                  this.const_list_today +
                  "/1?start=" +
                  this.today +
                  "&end=" +
                  this.today +
                  "&mode=notification" +
                  "&languageId=&search="
              )
              .then((response) => {
                // console.log(response.data);
                this.notification_list_today = response.data;
              })
              .catch((err) => {});
          }
        })
        .catch((err) => {});
    },
    getNotificationCounterYesterday() {
      this.setDate();
      this.axios
        .get(
          process.env.VUE_APP_API +
            "/api/v1/requestword/count?date=" +
            this.yesterday
        )
        .then((response) => {
          // console.log(response.data);
          this.notification_counter_yesterday_const = response.data.count;
          this.axios
            .get(
              process.env.VUE_APP_API +
                "api/v1/requestword/page/" +
                this.const_list_yesterday +
                "/1?start=" +
                this.yesterday +
                "&end=" +
                this.yesterday +
                "&mode=notification" +
                "&languageId=&search="
            )
            .then((response) => {
              // console.log(response.data);
              this.notification_list_yesterday = response.data;
            })
            .catch((err) => {});
        })
        .catch((err) => {});
    },
    setDate() {
      var now = new Date();
      this.today =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1 >= 10
          ? now.getMonth() + 1
          : "0" + (now.getMonth() + 1)) +
        "-" +
        (now.getDate() >= 10 ? now.getDate() : "0" + now.getDate().toString());
      var old = new Date();
      if (old.getDate() == 1) {
        old.setDate(0);
      } else {
        old.setDate(parseInt(old.getDate()) - 1);
      }
      this.yesterday =
        old.getFullYear() +
        "-" +
        (old.getMonth() + 1 >= 10
          ? old.getMonth() + 1
          : "0" + (old.getMonth() + 1)) +
        "-" +
        old.getDate();
    },
    formatAMPM(date_tmp) {
      var date = new Date(date_tmp);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    goPage(email) {
      this.$router.push({ name: "Request Word", query: { search: email } });
    },
  },
};
</script>
